

















































import { LabelOptional } from './../../../index';
import { i18n } from './../../../../i18n';
import { defineComponent, PropType, computed, ref } from '@vue/composition-api';
import { StrategyOption } from '../consts';
import StrategyPopover from '../strategy-popover/index.vue';
import BidStrategy from '../index';
import { useCurrencyOption } from '@tt4b/ttam-hooks';
import { formatNumberByLangCode } from '@tt4b/infra-utils';

const name = 'ttam-bid-strategy-target-item';
export default defineComponent({
  name,
  components: {
    StrategyPopover,
    LabelOptional,
    TtamBidStrategySet: BidStrategy.TtamBidStrategySet,
  },
  props: {
    value: {
      type: [String, Number],
      default: '',
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    labelTip: {
      type: String,
      default: '',
    },
    optional: {
      type: Boolean,
      default: false,
    },
    interpolation: {
      type: Object,
      default: () => ({}),
    },
    strategy: {
      type: Object as PropType<StrategyOption>,
      default: () => ({}),
    },
    settableStrategy: {
      type: Object as PropType<StrategyOption | undefined>,
      default: undefined,
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const { currencyOption } = useCurrencyOption();
    const _value = computed({
      get: () => props.value,
      set: v => {
        emit('change', v);
        emit('input', v);
      },
    });
    const formatMoney = num =>
      formatNumberByLangCode({
        value: num,
        platformLangCode: currencyOption.value?.langCode,
        precision: currencyOption.value?.precision,
      });
    const bidStrategyFormRef = ref();
    const bidValidateStatus = computed(() =>
      bidStrategyFormRef.value?.validateState === 'error' ? 'danger' : 'default',
    );
    const handleBidStrategyBlur = () => {
      bidStrategyFormRef.value?.onFieldBlur();
    };
    return {
      _value,
      formatMoney,
      bidValidateStatus,
      handleBidStrategyBlur,
      bidStrategyFormRef,
      name,
    };
  },
});
